// extracted by mini-css-extract-plugin
export var authContainer = "style-module--authContainer--1c727";
export var contents = "style-module--contents--8e9d6";
export var header = "style-module--header--87ef7";
export var headerContainer = "style-module--headerContainer--8ad0d";
export var history = "style-module--history--920d9";
export var label = "style-module--label--93558";
export var languageContainer = "style-module--languageContainer--3f42c";
export var loadingContainer = "style-module--loadingContainer--4e38e";
export var logoContainer = "style-module--logoContainer--60d8e";
export var menuSwitch = "style-module--menuSwitch--a6c85";
export var popupContainer = "style-module--popupContainer--a2e04";
export var save = "style-module--save--0ca16";